import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { TSCard } from '@/components/shared/card/Card';
import { TableLoader } from '@/components/shared/table/TableLoader';
import { RequestType } from '@/pages/team/teamMember/requests/RequestsTable.types';
import { useMyId } from '@/services/staff/useMyId';
import { FunctionComponent, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyRequestsHeader } from './MyRequestsHeader';
import { MyRequestsList } from './MyRequestsList';
import { MyRequestRow, useMyRequestRows } from './useMyRequestRows';

const MyRequestsContent: FunctionComponent = () => {
  const userId = useMyId();
  const navigate = useNavigate();
  const requests = useMyRequestRows(userId);

  // TODO: swap these for the employee-facing details routes
  const handleOpen = (request: MyRequestRow) => {
    switch (request.type) {
      case RequestType.ScheduleChange:
        navigate(`/ess/my-schedule/change-request/${request.id}`);
        break;
      case RequestType.LeaveRequest:
        navigate(`/ess/my-calendar/my-leave/${request.id}`);
        break;
      case RequestType.AvailabilityChange:
        navigate(`/ess/my-calendar/${request.startDate}/my-availability/${request.id}`);
        break;
    }
  };

  return (
    <TSCard>
      <MyRequestsList requests={requests} onOpen={handleOpen} />
    </TSCard>
  );
};

const MyRequests: FunctionComponent = () => (
  <PageContainer customHeader={<MyRequestsHeader />}>
    <Suspense fallback={<TableLoader />}>
      <PageSizer mode={SizerMode.PAGE} className="flex-1 overflow-auto space-y-4">
        <MyRequestsContent />
      </PageSizer>
    </Suspense>
  </PageContainer>
);

export default MyRequests;
